module.exports = __webpack_public_path__ + "img/expand-05.282847ba.svg";